<template>
    <div class="banner-search">
        <div class="bloc-recherche">
            <div class="recherche-text">
                <input type="search" v-model="filters.query" id="site-search" name="Tapez votre recherche ici..." placeholder="Tapez votre recherche ici..." @keyup.enter="submitSearch">
            </div>
            <div class="toggleMore">
                <label class="switch">
                    <input type="checkbox" name="togglemore" @click="toggleMore" v-model="isChecked">
                    <span class="slider round"></span>
                </label>
                <span class="labelMore">+ d'options</span>
            </div>
            <div class="submitSearch desktop">
                <input type="submit" value="Rechercher" class="btn btn-red" @click="submitSearch">
            </div>
        </div>
        <div class="bloc-more-wrapper" v-if="isShow">
            <div class="bloc-plus" >
                <div class="bloc-plus--item">
                    <h4>Rechercher par revue</h4>
                    <p v-for="abonnement in listePublications" :key="abonnement.id" >
                        <input type="radio" :id="'bar-' + abonnement.key" :value="abonnement.key" v-model="filters.nomrevue" />
                        <label :for="'bar-' + abonnement.key">{{ abonnement.key }}</label>
                    </p>
                </div>
                <div class="bloc-plus--item">
                    <h4>Rechercher par parution</h4>
                    <p>
                    <Field name="start-date-year" as="select"  v-model="filters.annee_debut" >
                        <option value="" selected>Année de début</option>
                        <option :value="startDate" v-for="startDate in getStartsDate()" :key="startDate">{{ startDate }}
                        </option>
                    </Field>
                    <Field name="end-date-year"  as="select" v-model="filters.annee_fin">
                        <option value="" selected>Année de fin</option>
                        <option :value="endDate" v-for="endDate in getEndsDate()" :key="endDate" >{{ endDate }}</option>
                    </Field>
                    </p>
                    <p>
                        <input type="text" id="revue-number" name="revue-number" placeholder="N° de la revue" v-model="filters.num_revue">
                        <Field name="publication-date-year" as="select"  v-model="filters.annee_parution">
                            <option value="" selected>Année de parution</option>
                            <option :value="parutionDate" v-for="parutionDate in getAnneeParution()" :key="parutionDate">{{ parutionDate }}</option>
                        </Field>
                    </p>
                    <p>
                        <input type="text" id="start-page" name="start-page" placeholder="Page de début" v-model="filters.page_debut">
                    </p>
                </div>
                <div class="submitSearch mobile">
                    <input type="submit" value="Rechercher" class="btn btn-red" @click="submitSearch">
                </div>
            </div>
            <div class="bloc-plus--footer">
                <div class="bloc-need-help">
                    <router-link :to="{ name: 'contactPage' }">Besoin d'aide ?</router-link>
                </div>
                <div class="resetSearch">
                    <input type="button" value="Réinitialiser" class="btn btn-link" @click="defaultFilters" :disabled="!activeReset">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters,mapActions } from 'vuex'
import { Field } from 'vee-validate';
import moment from "moment"

export default {
    name: "BarreRecherche",
    components: {
        Field,
    },
    data() {
        return {
            isShow: false,
            isChecked: false,
            filters: null,
            listePublications: [],
        }
    },
    watch:{
        getAbonnements: {
            handler(newVal) {
                this.setOnLoad(true);
                if (Array.isArray(newVal) && newVal.length > 0) {
                    this.$api4d.getPublications(this.auth.token).then(({ data }) => {
                        let publications = data.data;
                        // afficher abonné si dans abonnements
                        publications.forEach((element, index) => {
                            let abo = this.getAbonnements.find(f => f.key === element.key);
                            if (abo != undefined) {
                                publications[index]['hasAbonne'] = true;
                                publications[index]['isAbonne'] = abo.inProgress;
                                publications[index]['period'] = abo.period;
                            } else {
                                publications[index]['isAbonne'] = false;
                                if (element.key == "Le Concours médical" || element.key == "Concours pluripro") {
                                    let abo = this.getAbonnements.find(f => f.key === "Le Concours Pluripro");
                                    if (abo != undefined) {
                                        publications[index]['hasAbonne'] = true;
                                        publications[index]['isAbonne'] = abo.inProgress;
                                        publications[index]['period'] = abo.period;
                                    }
                                }
                            }
                        });
                        this.setPublications(publications);
                        this.listePublications = publications
                        this.setOnLoad(false);
                    }).catch((e) => {
                        this.setOnLoad(false);
                        console.log(e)
                    });
                }
            },
            immediate: true
        },
        filters: {
            handler() {
                this.activeReset = this.checkActiveReset();
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.originalQuery = this.getSearchFilters.query;

        let open = false;

        for (const property in this.getSearchFilters) {
            if (property != "documentId" && property != "sort" && property != "offset" && property != "motcle" && property != "rubrique" && property != "specialite") {
                if (Array.isArray(this.getSearchFilters[property])) {
                    if (this.getSearchFilters[property].length > 0){
                        open = true;
                    }
                } else {
                    if (this.getSearchFilters[property] != null && this.getSearchFilters[property] != '') {
                        open = true;
                    }
                }
            }
        }

        if (open) {
            this.isChecked = true;
            this.isShow = true;
        }
    },
    computed: {
        ...mapState([
            'auth'
        ]),
        ...mapGetters([
            'getAbonnements',
            'getAbonnementsStartDates',
            'getAbonnementsEndDates',
            'getSearchFilters',
            'getStartDatesRevue',
            'getPublications'
        ]),
        activeReset() {
            return this.checkActiveReset();
        }
    },
    methods: {
        ...mapActions([
            'setSearchFilters',
            'setOnLoad',
            'setPublications'
        ]),
        toggleMore(e) {
            this.isChecked = e.target.checked
            this.isShow = e.target.checked
        },
        getAnneeParution() {
            return this.getDatesDefault();
        },
        submitSearch() {
            // Reset filters if search has changed.
            if (this.filters.query != null && this.filters.query.trim() != this.originalQuery) {
                this.defaultFilters(false);
                this.setSearchFilters(this.filters);
            }
            else {
                this.setSearchFilters(this.filters);
            }
            this.$emit('submitSearch');
            if(this.filters.query != null){
                this.originalQuery = this.filters.query.trim();
            }
        },
        defaultFilters(all = true) {
            this.filters.offset = 0;

            if (all) {
                this.filters.rubrique = [];
                this.filters.specialite = [];
                this.filters.annee_debut = null;
                this.filters.annee_fin = null;
                this.filters.annee_parution = null;
                this.filters.documentId = '';
                this.filters.page_debut = null;
                this.filters.motcle = [];
                this.filters.nomrevue = [];
                this.filters.num_revue = null;
                this.filters.sort = '';
                this.filters.query = '';
            }
        },
        getStartsDate() {
            return this.getDatesDefault();
        },
        getEndsDate() {
            return this.getDatesDefault()
        },
        getDatesDefault() {
            let dates = [];
            for (let i = 2001; i <= moment().format('YYYY'); i++) {
                dates.push(i);
            }
            return this.sort(dates);
        },
        sort(array) {
            return array.sort((date1, date2) => date2 - date1);
        },
        checkActiveReset() {
            if (!this.filters) return false;

            return Object.keys(this.filters).some(key => {
                // Ignorer les champs qui ne sont pas des filtres
                if (['documentId', 'sort', 'offset', 'motcle', 'rubrique', 'specialite'].includes(key)) return false;

                const value = this.filters[key];
                if (Array.isArray(value)) return value.length > 0;
                return value !== null && value !== '';
            });
        },
    },
    created() {
        this.filters = this.getSearchFilters;

        // get Liste revue
        this.setOnLoad(true);

        if (this.getPublications != null) {
            this.listePublications = this.getPublications
            this.setOnLoad(false);
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/scss/helpers/mixins";
@import "@/scss/helpers/variables";

.bloc-recherche {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;

    .recherche-text {
        display: flex;
        align-items: center;
        flex: 0 1 60%;

        &::before {
            content: '';
            display: block;
            background: url('@/assets/images/Search\ Icon.png') no-repeat center;
            width: 24px;
            height: 24px;
            padding-left: 40px;
        }
        input {
            border: none;
            padding-left: 0;
        }
    }

    .toggleMore {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .switch {
            position: relative;
            display: inline-block;
            width: 60px;
            height: 34px;
            input {
                opacity: 0;
                width: 0;
                height: 0;
            }

            .slider {
                position: absolute;
                cursor: pointer;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: #ccc;
                // -webkit-transition: .4s;
                transition: .4s;
                &::before {
                    position: absolute;
                    content: "";
                    height: 26px;
                    width: 26px;
                    left: 4px;
                    bottom: 4px;
                    background-color: white;
                    // -webkit-transition: .4s;
                    transition: .4s;
                }
                &.round {
                    border-radius: 34px;
                    &::before {
                        border-radius: 50%;
                    }
                }
                @media screen and (max-width:768px) {
                    transform: scale(.7);
                }
            }

            input:checked + .slider {
                background-color: #283861;
            }

            input:focus + .slider {
                box-shadow: 0 0 1px #283861;
            }

            input:checked + .slider:before {
                // -webkit-transform: translateX(26px);
                // -ms-transform: translateX(26px);
                transform: translateX(26px);
            }
        }

        .labelMore {
            color: $main;
            font-family: $campaign;
            font-size: 10px;
            font-weight: $bold;
            margin: 0 10px 0 0;

            @include min($lg) {
                margin: 0 10px;
                font-size: 15px;
            }
        }
    }
}

.banner-search {
    background: #fff;
    max-width: 900px;
    border-radius: 30px;
    border: 0;
    margin: 3rem auto;

    @include min($lg) {
        margin: 5em auto;
    }

    .bloc-plus {
        padding: 20px 32px 0;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;

        @include min($lg) {
            padding: 20px 20px 0;
            flex-direction: row;
        }


        &--item {
            gap: 20px;
            margin: 0 10px;

            @include min($lg) {
                gap: 40px;
            }

            &__title {
                text-align: center;

                @include min($lg) {
                text-align: left;
                }
            }
        }

        &__header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0;

            @include min($lg) {
                display: block;
                margin: 0 10px;
            }

            h4 {
                font-size: 14px;

                @include min($lg) {
                    font-size: 16px;
                }
            }

            select {
                max-width: 160px;

                @include min($lg) {
                    max-width: 100%;
                }
            }
        }

        .bloc-plus--item{
            h4 {
                margin: 0 0 10px;
            }

            p{
                margin: 0;
                display: flex;
                gap: 10px;
                position: relative;

                > * {
                    margin: 0 0 10px;
                }
            }
        }
    }

    .bloc-need-help {
        text-align: center;
        padding: 20px 32px;
        font-weight: bold;

        @include min($lg) {
            padding: 0 18px;
            text-align: inherit;
        }

        a {
            text-decoration: none;
            font-family: $campaign;
            font-weight: $bold;
            &::before {
                content:'';
                display: inline-block;
                vertical-align: middle;
                background: url('@/assets/images/help-icon.svg') no-repeat center;
                width: 20px;
                height: 20px;
                margin-right: 5px;
            }
        }
    }

    .bloc-plus--footer {
        display: flex;
        justify-content: flex-start;
        flex-direction: column-reverse;
        
        @include min($md) {
            padding: 10px 0px;
            align-items: center;
            justify-content: space-between;
            flex-direction: row;
        }
    }

    .resetSearch {
        padding: 10px 32px;
        text-align: center;

        @include min($md) {
            padding: 0 10px;
            text-align: inherit;
        }

        input {
            width: 100%;

            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
                background-color: #ccc;
            }
        }
        
    }
}
</style>